<template>
	<v-card>
		<v-card-title>
			<translate>{{ title }}</translate>
		</v-card-title>
		<v-card-text>
			<div
				v-for="(item, key) in items"
				:key="item"
			>
				<v-row>
					<v-col>
						<translate class="text-primary">
							{{ formatString(key) }}
						</translate>
						<v-text-field
							:model-value="items[key]"
							style="font-size: 100%"
							readonly
							variant="outlined"
						/>
					</v-col>
				</v-row>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'ModelDetail',
	props: {
		title: {
			type: String,
			required: true,
		},
		items: {
			type: Object,
			required: true,
		}
	},
	methods: {
		/**
		 * Add spaces between capitals of a string
		 *
		 * @param {string} string The string to add spaces to
		 * @returns {string} String with spaces
		 */
		formatString (string) {
			const spacedString = string.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');

			return spacedString.charAt(0).toUpperCase() + spacedString.slice(1);
		}
	}
};
</script>

